'use client'

import { SizeDataCategory } from '@/types/size'
import { useTranslations } from 'next-intl'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { useProductDetailStore } from '../../hooks/use-product-detail-store'
import { InstructionSize } from '../product-info-sizes/instructions-size'
import { InfoSizeShortItem } from './info-size-short-item'
export const InfoSizesShort = ({
  sizeChart,
  gender_type,
  size_guide,
}: {
  sizeChart: string
  gender_type: string
  size_guide: SizeDataCategory
}) => {
  const { sizeSelected, setSizeSelected, sizeOptions, product } =
    useProductDetailSafe()
  const { isDisableSize } = useProductDetailStore()
  const t = useTranslations('title')

  if (!sizeOptions.length) return null

  return (
    <div className='border-l border-l-neutral-200 py-4 pl-2 2xl:pl-6'>
      <p className='mb-1 text-sm leading-4.5 text-neutral-600'>
        {t('size')}:
        <span className='ml-3 font-semibold text-neutral-900'>
          {' '}
          {sizeSelected}
        </span>
      </p>
      <ul className='flex flex-wrap gap-2 gap-y-3'>
        {sizeOptions.map((sizeOption, index) => (
          <InfoSizeShortItem
            key={index}
            isActive={sizeSelected === sizeOption}
            onClick={() =>
              !isDisableSize(sizeOption) && setSizeSelected(sizeOption)
            }
            title={sizeOption}
            isDisabled={isDisableSize(sizeOption)}
          />
        ))}
      </ul>
      <InstructionSize
        sizeChart={sizeChart}
        gender_type={gender_type}
        size_guide={size_guide}
        productId={product.id}
        product={product}
      />
    </div>
  )
}
